module.exports = __webpack_public_path__ + "img/load.421edc0b.png";